function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "210",
  height: "182",
  viewBox: "0 0 210 182",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  opacity: ".3",
  x: "1",
  y: "140",
  width: "209",
  height: "42",
  rx: "10",
  fill: "#39C360"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: ".3",
  width: "207",
  height: "130",
  rx: "10",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 69c0-5.523 4.477-10 10-10h187c5.523 0 10 4.477 10 10v51c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10V69z",
  fill: "url(#paint0_linear_1687_163)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".2",
  fill: "#fff",
  d: "M17 157h176v8H17zM17 108h85v8H17z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1687_163",
  x1: "103.5",
  y1: "59",
  x2: "103.744",
  y2: "129.999",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#12002D",
  stopOpacity: "0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#12002D",
  stopOpacity: ".69"
})))));